<div class="policy-wrap">
  <h1>Cookies Policy</h1>
  <p class="subtitle">Last updated: 30/05/2022</p>
  <p>
    We recommend that you read this Cookie page in full to ensure you are fully
    informed. However, if you only want to access a particular section of this
    Cookie page, then you can click on the relevant link below to jump to that
    section.
  </p>
  <p><a href="/cookie-policy/#1">Cookies list</a></p>
  <p><a href="/cookie-policy/#2">Where Can I Get Further Information?</a></p>
  <p><a href="/cookie-policy/#3">Managing cookies</a></p>

  <a id="1"></a>
  <h2>Cookies list</h2>
  <p>
    A cookie is a small piece of data (text file) that a website – when visited
    by a user – asks your browser to store on your device in order to remember
    information about you, such as your language preference or login
    information. Those cookies are set by us and called first-party cookies. We
    also use third-party cookies – which are cookies from a domain different
    than the domain of the website you are visiting – for our advertising and
    marketing efforts. More specifically, we use cookies and other tracking
    technologies for the following purposes:
  </p>
  <h3>Necessary cookies</h3>
  <p>What are necessary cookies?</p>
  <p>
    These cookies are necessary for the website to function and cannot be
    switched off in our systems. They are usually only set in response to
    actions made by you which amount to a request for services, such as setting
    your privacy preferences, logging in or filling in forms. You can set your
    browser to block or alert you about these cookies, but some parts of the
    site will not then work.
  </p>

  <div class="table">
    <div class="table-head">
      <div class="cell">Group</div>
      <div class="cell">Cookies</div>
      <div class="cell">Cookies used</div>
      <div class="cell">Lifespan</div>
    </div>
    <div class="table-row">
      <div class="cell">community.petsathome.com</div>
      <div class="cell">JSESSIONID</div>
      <div class="cell">First party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">cloud.digital.petsathome.com</div>
      <div class="cell">
        gtmPetPlanCampaign, gtmPetPlanData, gtmPetPlanSession
      </div>
      <div class="cell">First party</div>
      <div class="cell">Session, Session, Session</div>
    </div>
    <div class="table-row">
      <div class="cell">.petsathome.com</div>
      <div class="cell">
        cookiePolicy, OptanonAlertBoxClosed, OptanonConsent, pref_store,
        WC_OCHECK, WC_PAH_PERSONALISED
      </div>
      <div class="cell">First party</div>
      <div class="cell">
        365 Days, 365 Days, 365 Days, 15 Months, Session, Session
      </div>
    </div>
    <div class="table-row">
      <div class="cell">investors.petsathome.com</div>
      <div class="cell">ARRAffinity, ARRAffinitySameSite</div>
      <div class="cell">First party</div>
      <div class="cell">Session, Session</div>
    </div>
    <div class="table-row">
      <div class="cell">www.petsathome.com</div>
      <div class="cell">
        _mitata, cf_chl_2, cf_chl_cc_, cf_chl_prog, cf_chl_rc_ni, cf_use_ob,
        logglytrackingsession, priceMode, tduc, WC_ACTIVEPOINTER,
        WC_AUTHENTICATION_-1002, WC_AUTHENTICATION_xxxxxxxx,
        WC_GENERIC_ACTIVITYDATA, WC_MOBILEDEVICEID, WC_PERSISTENT,
        WC_SESSION_ESTABLISHED, WC_USERACTIVITY_-1002, WC_USERACTIVITY_XXXXX
      </div>
      <div class="cell">First party</div>
      <div class="cell">
        A few seconds, A few seconds, A few seconds, A few seconds, A few
        seconds, A few seconds, Session, Session, A few seconds, Session,
        Session, Session, Session, Session, Session, Session, Session, Session
      </div>
    </div>
    <div class="table-row">
      <div class="cell">petsathome.com</div>
      <div class="cell">
        _dc_gtm_UA-xxxxxxxx, _ga, _gat, _gat_gtag_xxxxxxxxxxxxxxxxxxxxxxxxxxx,
        _gat_UA-6022948-2, _gat_xxxxxxxxxxxxxxxxxxxxxxxxxx, _gclxxxx, _gid,
        _pahGA, _pahGA_gid, ABTasty, ABTastyDomainTest, ABTastySession
      </div>
      <div class="cell">First party</div>
      <div class="cell">
        A few seconds, A few seconds, A few seconds, A few seconds, A few
        seconds, A few seconds, A few seconds, A few seconds, A few seconds, A
        few seconds, 13 Months, Session, A few seconds
      </div>
    </div>
    <div class="table-row">
      <div class="cell">main.b2cadmin.ext.azure.com</div>
      <div class="cell">x-ms-cpim-admin</div>
      <div class="cell">Third party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">www.tailster.com</div>
      <div class="cell">ARRAffinity, ARRAffinitySameSite</div>
      <div class="cell">Third party</div>
      <div class="cell">Session, Session</div>
    </div>
    <div class="table-row">
      <div class="cell">www.petsathomejobs.com</div>
      <div class="cell">CAKEPHP</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">fonts.net</div>
      <div class="cell">__cf_bm</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">
        b2clogin.com, login.microsoftonline.com, petsathome.com
      </div>
      <div class="cell">
        x-ms-cpim-cache:{{ '{' }}id{{ '}' }}_n, x-ms-cpim-csrf, x-ms-cpim-ctx,
        x-ms-cpim-dc, x-ms-cpim-rc, x-ms-cpim-rp, x-ms-cpim-slice,
        x-ms-cpim-sso:{{ '{' }}Id{{ '}' }}, x-ms-cpim-trans
      </div>
      <div class="cell">Third party</div>
      <div class="cell">
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session
      </div>
    </div>
    <div class="table-row">
      <div class="cell">.google.com</div>
      <div class="cell">__Secure-3PSIDCC</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">.cybersource.com</div>
      <div class="cell">__cfruid, JSESSIONID</div>
      <div class="cell">Third party</div>
      <div class="cell">Session, Session</div>
    </div>
    <div class="table-row">
      <div class="cell">gis.goinstore.com</div>
      <div class="cell">AWSALB, AWSALBCORS, logglytrackingsession</div>
      <div class="cell">Third party</div>
      <div class="cell">7 Days, 7 Days, Session</div>
    </div>
    <div class="table-row">
      <div class="cell">CookieControl</div>
      <div class="cell">CookieControl</div>
      <div class="cell">First party</div>
      <div class="cell">58 days</div>
    </div>
    <div class="table-row">
      <div class="cell">clinicCode</div>
      <div class="cell">clinicCode</div>
      <div class="cell">First party</div>
      <div class="cell">365 days</div>
    </div>
  </div>

  <h3>Functional cookies</h3>
  <p>What are functional cookies?</p>
  <p>
    These cookies enable the website to provide enhanced functionality and
    personalisation. They may be set by us or by third party providers whose
    services we have added to our pages. If you do not allow these cookies then
    some or all of these services may not function properly.
  </p>

  <div class="table">
    <div class="table-head">
      <div class="cell">Cookie subgroup</div>
      <div class="cell">Cookies</div>
      <div class="cell">Cookies used</div>
      <div class="cell">Lifespan</div>
    </div>
    <div class="table-row">
      <div class="cell">petsathome.com</div>
      <div class="cell">__pr.96n, _br_uid_2, rr_rcs</div>
      <div class="cell">First party</div>
      <div class="cell">A few seconds, A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">force.com</div>
      <div class="cell">
        BrowserId, BrowserId_sec, force-stream, language, sfdc-stream
      </div>
      <div class="cell">Third party</div>
      <div class="cell">
        365 Days, 365 Days, A few seconds, Session, A few seconds
      </div>
    </div>
    <div class="table-row">
      <div class="cell">richrelevance.com</div>
      <div class="cell">mvtid</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">recs.richrelevance.com</div>
      <div class="cell">cv, m, n, psthc, pv, s, sthc, uc</div>
      <div class="cell">Third party</div>
      <div class="cell">
        A few seconds, A few seconds, A few seconds, A few seconds, A few
        seconds, A few seconds, A few seconds, A few seconds
      </div>
    </div>
    <div class="table-row">
      <div class="cell">service.force.com</div>
      <div class="cell">CookieConsentPolicy</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">d.la1-c2-lo3.salesforceliveagent.com</div>
      <div class="cell">X-Salesforce-CHAT</div>
      <div class="cell">Third party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">bookingbug.com</div>
      <div class="cell">bbsidUK</div>
      <div class="cell">Third party</div>
      <div class="cell">Session</div>
    </div>
  </div>

  <h3>Performance cookies</h3>
  <p>What are performance cookies?</p>
  <p>
    These cookies allow us to count visits and traffic sources so we can measure
    and improve the performance of our site. They help us to know which pages
    are the most and least popular and see how visitors move around the site.
    All information these cookies collect is aggregated and therefore anonymous.
    If you do not allow these cookies we will not know when you have visited our
    site, and will not be able to monitor its performance.
  </p>

  <div class="table">
    <div class="table-head">
      <div class="cell">Cookie subgroup</div>
      <div class="cell">Cookies</div>
      <div class="cell">Cookies used</div>
      <div class="cell">Lifespan</div>
    </div>
    <div class="table-row">
      <div class="cell">www.petsathome.com</div>
      <div class="cell">ADRUM_BT1, ADRUM_BT2, ADRUM_BTa, ADRUM_BTs, aluid</div>
      <div class="cell">First party</div>
      <div class="cell">
        A few seconds, A few seconds, A few seconds, A few seconds, A few
        seconds
      </div>
    </div>
    <div class="table-row">
      <div class="cell">cloud.digital.petsathome.com</div>
      <div class="cell">
        _hjCachedUserAttributes, _hjIncludedInPageviewSample,
        _hjIncludedInSessionSample
      </div>
      <div class="cell">First party</div>
      <div class="cell">Session, A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">petsathome.com</div>
      <div class="cell">
        _ga_CNSHY37GMP, _hjAbsoluteSessionInProgress, _hjFirstSeen, _hjid,
        _hjTLDTest, _pahGA_ga
      </div>
      <div class="cell">First party</div>
      <div class="cell">
        729 Days, A few seconds, A few seconds, A few seconds, Session, 729 Days
      </div>
    </div>
    <div class="table-row">
      <div class="cell">script.hotjar.com</div>
      <div class="cell">
        _hjCachedUserAttributes, _hjDonePolls, _hjIncludedInPageviewSample,
        _hjIncludedInSessionSample
      </div>
      <div class="cell">Third party</div>
      <div class="cell">Session, 365 Days, A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">sc-static.net</div>
      <div class="cell">X-AB</div>
      <div class="cell">Third party</div>
      <div class="cell">1 Day</div>
    </div>
  </div>

  <h3>Targeting cookies</h3>
  <p>What are targeting cookies?</p>
  <p>
    These cookies may be set through our site by our advertising partners. They
    may be used by those companies to build a profile of your interests and show
    you relevant adverts on other sites. They do not store directly personal
    information, but are based on uniquely identifying your browser and internet
    device. If you do not allow these cookies, you will experience less targeted
    advertising.
  </p>

  <div class="table">
    <div class="table-head">
      <div class="cell">Cookie subgroup</div>
      <div class="cell">Cookies</div>
      <div class="cell">Cookies used</div>
      <div class="cell">Lifespan</div>
    </div>
    <div class="table-row">
      <div class="cell">.petsathome.com</div>
      <div class="cell">dtm_token, dtm_token_sc, ividData</div>
      <div class="cell">First party</div>
      <div class="cell">13 Months, 13 Months, 365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">www.petsathome.com</div>
      <div class="cell">cf_chl_seq_</div>
      <div class="cell">First party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">cloud.digital.petsathome.com</div>
      <div class="cell">_cs_same_site</div>
      <div class="cell">First party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">petsathome.com</div>
      <div class="cell">
        __qca, _cs_id, _cs_mk_ga, _cs_root-domain, _cs_s, _cs_tld1643155677704,
        _cs_tld1643155971326, _cs_tld1643156318610, _cs_tld1643156669445,
        _cs_tld1643157078939, _cs_tld1643157217744, _cs_tld1643157373509,
        _cs_tld1643157717888, _cs_tld1643158174332, _cs_tld1643158558175,
        _cs_tld1643158781683, _cs_tld1643159057016, _cs_tld1643159394278,
        _cs_tld1643159574909, _cs_tld1643159775352, _cs_tld1643159960557,
        _cs_tld1643160361070, _cs_tld1643160535307, _cs_tld1643161152290,
        _cs_tld1643161382430, _cs_tld1643161646656, _cs_tld1643161754042,
        _cs_tld1643162377973, _cs_tld1643162728184, _cs_tld1643163004845,
        _cs_tld1643163461231, _cs_tld1643163699147, _cs_tld1643164143390,
        _cs_tld1643164772716, _cs_tld1643165356303, _cs_tld1643165517654,
        _cs_tld1643165899595, _cs_tld1643166066822, _cs_tld1643166280751,
        _cs_tld1643166509276, _cs_tld1643166968714, _cs_tld1643167364339,
        _cs_tld1643167698274, _cs_tld1643167885448, _cs_tld1643168024267,
        _cs_tld1643168277245, _cs_tld1643168393573, _cs_tld1643168560760,
        _cs_tld1643172375043, _cs_tld1643172766295, _cs_tld1643172937198,
        _cs_tld1643173442377, _cs_tld1643173902552, _cs_tld1643174067150,
        _cs_tld1643174262447, _cs_tld1643174426123, _cs_tld1643174671139,
        _cs_tld1643174833309, _cs_tld1643175017022, _cs_tld1643175165194,
        _cs_tld1643175287830, _cs_tld1643175408229, _cs_tld1643175586915,
        _cs_tld1643175800756, _cs_tld1643175960982, _cs_tld1643176214160,
        _cs_tld1643176705083, _cs_tld1643176911371, _cs_tld1643177225355,
        _cs_tld1643177354559, _cs_tld1643177770045, _cs_tld1643177907586,
        _cs_tld1643178317841, _cs_tld1643178850999, _cs_tld1643179022276,
        _cs_tld1643179278633, _cs_tld1643179693095, _cs_tld1643179810751,
        _cs_tld1643179930209, _cs_tld1643180114101, _cs_tld1643180262556,
        _cs_tld1643180556464, _cs_tld1643180679684, _cs_tld1643180805510,
        _cs_tld1643181479851, _cs_tld1643181790849, _cs_tld1643182563212,
        _cs_tld1643182718178, _cs_tld1643183051760, _cs_tld1643183355244,
        _cs_tld1643183495090, _cs_tld1643183988440, _cs_tld1643184195720,
        _cs_tld1643184378003, _cs_tld1643184591370, _cs_tld1643185057094,
        _cs_tld1643185228283, _cs_tld1643185346713, _cs_tld1643186114774,
        _cs_tld1643186448160, _cs_tld1643186556642, _cs_tld1643186692128,
        _cs_tld1643186922350, _cs_tld1643187312505, _cs_tld1643187447889,
        _cs_tld1643187725665, _cs_tld1643188114427, _cs_tld1643188260691,
        _cs_tld1643188521472, _cs_tld1643188826780, _cs_tld1643188988970,
        _cs_tld1643189635263, _cs_tld1643190104500, _cs_tld1643190231168,
        _cs_tld1643190931596, _cs_tld1643192747971, _cs_tld1643193555625,
        _cs_tld1643194023302, _cs_tld1643198049458, _cs_tld1643198444865,
        _cs_tld1643200810949, _cs_tld1643201554277, _cs_tld1643201887494,
        _cs_tld1643208679103, _dlt, _schn, _uetsid, _scid, stc111507, rmStore
      </div>
      <div class="cell">First party</div>
      <div class="cell">
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session, Session, Session, Session, Session, Session, Session,
        Session, Session
      </div>
    </div>
    <div class="table-row">
      <div class="cell">spotxchange.com</div>
      <div class="cell">audience</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">outbrain.com</div>
      <div class="cell">bdswch, obuid</div>
      <div class="cell">Third party</div>
      <div class="cell">30 Days, 90 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">dpm.demdex.net</div>
      <div class="cell">dpm</div>
      <div class="cell">Third party</div>
      <div class="cell">180 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">analytics.yahoo.com</div>
      <div class="cell">IDSYNC</div>
      <div class="cell">Third party</div>
      <div class="cell">366 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">nxtck.com</div>
      <div class="cell">ccv2, uuid</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days, 365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">semasio.net</div>
      <div class="cell">SEUNCY</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">4dex.io</div>
      <div class="cell">uids</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">ad.outstream.today</div>
      <div class="cell">bdswtch_sync, moxuuid</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">sharethrough.com</div>
      <div class="cell">stx_user_id</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">lemmatechnologies.com</div>
      <div class="cell">uid, uids</div>
      <div class="cell">Third party</div>
      <div class="cell">90 Days, 90 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">gumgum.com</div>
      <div class="cell">vst</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">embedded.wishpondpages.com</div>
      <div class="cell">wishpond</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">tools.eurolandir.com</div>
      <div class="cell">
        __RequestVerificationToken_L3Rvb2xzL1N1YnNjcmlwdGlvbkNlbnRyZTI1
      </div>
      <div class="cell">Third party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">vimeo.com</div>
      <div class="cell">vuid</div>
      <div class="cell">Third party</div>
      <div class="cell">730 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">ads.avct.cloud</div>
      <div class="cell">uuid</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">i.liadm.com</div>
      <div class="cell">_li_ss</div>
      <div class="cell">Third party</div>
      <div class="cell">30 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">mathtag.com</div>
      <div class="cell">mt_mop, uuid</div>
      <div class="cell">Third party</div>
      <div class="cell">30 Days, 393 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">admanmedia.com</div>
      <div class="cell">admtr</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">bh.contextweb.com</div>
      <div class="cell">INGRESSCOOKIE</div>
      <div class="cell">Third party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">tapad.com</div>
      <div class="cell">TapAd_3WAY_SYNCS, TapAd_DID, TapAd_TS</div>
      <div class="cell">Third party</div>
      <div class="cell">60 Days, 60 Days, 60 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">exelator.com</div>
      <div class="cell">EE, ud</div>
      <div class="cell">Third party</div>
      <div class="cell">120 Days, 120 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">ad.mediawayss.com</div>
      <div class="cell">bdswtch_sync, moxuuid</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">ad.mox.tv</div>
      <div class="cell">bdswtch_sync, moxuuid</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">id5-sync.com</div>
      <div class="cell">3pi, callback, car, cf, cip, cnac, gdpr, id5</div>
      <div class="cell">Third party</div>
      <div class="cell">
        90 Days, A few seconds, A few seconds, A few seconds, A few seconds, A
        few seconds, A few seconds, 90 Days
      </div>
    </div>
    <div class="table-row">
      <div class="cell">rmp.rakuten.com</div>
      <div class="cell">icts, rmuid</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days, 365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">ih.adscale.de</div>
      <div class="cell">tu</div>
      <div class="cell">Third party</div>
      <div class="cell">363 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">bing.com</div>
      <div class="cell">MUID</div>
      <div class="cell">Third party</div>
      <div class="cell">390 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">ad.vidverto.io</div>
      <div class="cell">bdswtch_sync, moxuuid</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">advertising.com</div>
      <div class="cell">APID</div>
      <div class="cell">Third party</div>
      <div class="cell">366 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">audiencemanager.de</div>
      <div class="cell">Nano, NmpAppNexus, NmpDBM, NmpEMX</div>
      <div class="cell">Third party</div>
      <div class="cell">
        A few seconds, A few seconds, A few seconds, A few seconds
      </div>
    </div>
    <div class="table-row">
      <div class="cell">unrulymedia.com</div>
      <div class="cell">_rxuuid</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">vidoomy.com</div>
      <div class="cell">vidoomy-uids</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">adnxs.com</div>
      <div class="cell">anj, uuid2</div>
      <div class="cell">Third party</div>
      <div class="cell">90 Days, 90 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">youtube.com</div>
      <div class="cell">
        CONSENT, nextId, remote_sid, requests, VISITOR_INFO1_LIVE, YSC
      </div>
      <div class="cell">Third party</div>
      <div class="cell">
        A few seconds, A few seconds, Session, A few seconds, 180 Days, Session
      </div>
    </div>
    <div class="table-row">
      <div class="cell">edge.quantserve.com</div>
      <div class="cell">_dlt</div>
      <div class="cell">Third party</div>
      <div class="cell">364 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">sync.outbrain.com</div>
      <div class="cell">cookieJartestCookie</div>
      <div class="cell">Third party</div>
      <div class="cell">1 Day</div>
    </div>
    <div class="table-row">
      <div class="cell">taboola.com</div>
      <div class="cell">t_gid</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">media.net</div>
      <div class="cell">data-bs, data-co, gdpr_status</div>
      <div class="cell">Third party</div>
      <div class="cell">364 Days, 364 Days, 185 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">casalemedia.com</div>
      <div class="cell">CMID, CMPRO, CMPS, CMRUM3, CMST</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days, 90 Days, 90 Days, 365 Days, 1 Day</div>
    </div>
    <div class="table-row">
      <div class="cell">igodigital.com</div>
      <div class="cell">
        igodigitalst_510000985, igodigitalstdomain, igodigitaltc2
      </div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds, A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">adform.net</div>
      <div class="cell">C</div>
      <div class="cell">Third party</div>
      <div class="cell">30 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">ads.stickyadstv.com</div>
      <div class="cell">sessionId, UID, uid-bp-529, uid-bp-xxxxx</div>
      <div class="cell">Third party</div>
      <div class="cell">Session, 30 Days, 60 Days, 60 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">dyntrk.com</div>
      <div class="cell">dyn_u</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">crwdcntrl.net</div>
      <div class="cell">_cc_aud, _cc_cc, _cc_dc, _cc_id</div>
      <div class="cell">Third party</div>
      <div class="cell">270 Days, Session, 270 Days, 270 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">rd.linksynergy.com</div>
      <div class="cell">cID, pID</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days, 365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">yahoo.com</div>
      <div class="cell">A3, APID, APIDTS, B</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days, 114 Days, 1 Day, 365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">ad.vidver.to</div>
      <div class="cell">bdswtch_sync, moxuuid</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">twitter.com</div>
      <div class="cell">personalization_id</div>
      <div class="cell">Third party</div>
      <div class="cell">730 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">liadm.com</div>
      <div class="cell">lidid</div>
      <div class="cell">Third party</div>
      <div class="cell">730 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">t.contentsquare.net</div>
      <div class="cell">_cs_c, _cs_id, _cs_s, _cs_same_site</div>
      <div class="cell">Third party</div>
      <div class="cell">384 days, 384 days, 384 days. Session</div>
    </div>
    <div class="table-row">
      <div class="cell">ad.invamia.com</div>
      <div class="cell">bdswtch_sync, moxuuid</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">creative-serving.com</div>
      <div class="cell">c, tuuid, tuuid_lu</div>
      <div class="cell">Third party</div>
      <div class="cell">390 Days, 390 Days, 390 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">bluekai.com</div>
      <div class="cell">bkpa, bku</div>
      <div class="cell">Third party</div>
      <div class="cell">181 Days, 181 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">360yield.com</div>
      <div class="cell">tuuid, tuuid_lu, um, umeh</div>
      <div class="cell">Third party</div>
      <div class="cell">90 Days, 90 Days, 90 Days, 90 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">krxd.net</div>
      <div class="cell">_kuid_</div>
      <div class="cell">Third party</div>
      <div class="cell">180 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">zeotap.com</div>
      <div class="cell">zc</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">www.facebook.com</div>
      <div class="cell"></div>
      <div class="cell">Third party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">doubleclick.net</div>
      <div class="cell">IDE, test_cookie</div>
      <div class="cell">Third party</div>
      <div class="cell">390 Days, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">openx.net</div>
      <div class="cell">i</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">agkn.com</div>
      <div class="cell">ab, u</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days, 364 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">go.sonobi.com</div>
      <div class="cell">HAPLB5S</div>
      <div class="cell">Third party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">demdex.net</div>
      <div class="cell">demdex</div>
      <div class="cell">Third party</div>
      <div class="cell">180 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">adsrvr.org</div>
      <div class="cell">TDCPM, TDID</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days, 365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">revlifter.io</div>
      <div class="cell">REVLIFTER</div>
      <div class="cell">Third party</div>
      <div class="cell">1 Day</div>
    </div>
    <div class="table-row">
      <div class="cell">adswizz.com</div>
      <div class="cell">OAID</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">eyeota.net</div>
      <div class="cell">SERVERID</div>
      <div class="cell">Third party</div>
      <div class="cell">Session</div>
    </div>
    <div class="table-row">
      <div class="cell">youtu.be</div>
      <div class="cell">CONSENT</div>
      <div class="cell">Third party</div>
      <div class="cell">5942 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">betweendigital.com</div>
      <div class="cell">dc, tuuid, ut</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds, A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">quantserve.com</div>
      <div class="cell">d, mc</div>
      <div class="cell">Third party</div>
      <div class="cell">89 Days, 396 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">t.visx.net</div>
      <div class="cell">c, tuuid, tuuid_lu, um2</div>
      <div class="cell">Third party</div>
      <div class="cell">
        A few seconds, A few seconds, A few seconds, A few seconds
      </div>
    </div>
    <div class="table-row">
      <div class="cell">tags.rd.linksynergy.com</div>
      <div class="cell">nxtck-identity-mgmt</div>
      <div class="cell">Third party</div>
      <div class="cell">1 Day</div>
    </div>
    <div class="table-row">
      <div class="cell">secure.quantserve.com</div>
      <div class="cell">_dlt</div>
      <div class="cell">Third party</div>
      <div class="cell">2914019 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">linksynergy.com</div>
      <div class="cell">icts, rmuid</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days, 365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">snapchat.com</div>
      <div class="cell">sc_at</div>
      <div class="cell">Third party</div>
      <div class="cell">390 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">sxp.smartclip.net</div>
      <div class="cell">dspuuid, psyn, uuid</div>
      <div class="cell">Third party</div>
      <div class="cell">30 Days, 30 Days, 30 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">adscale.de</div>
      <div class="cell">cct, uu</div>
      <div class="cell">Third party</div>
      <div class="cell">363 Days, 363 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">everesttech.net</div>
      <div class="cell">everest_g_v2</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">pubmatic.com</div>
      <div class="cell">
        chkChromeAb67Sec, ipc, KADUSERCOOKIE, KRTBCOOKIE_xxxx, PUBMDCID, PugT,
        SPugT
      </div>
      <div class="cell">Third party</div>
      <div class="cell">
        90 Days, A few seconds, 90 Days, 30 Days, 90 Days, 30 Days, 30 Days
      </div>
    </div>
    <div class="table-row">
      <div class="cell">bidswitch.net</div>
      <div class="cell">c, tuuid, tuuid_lu</div>
      <div class="cell">Third party</div>
      <div class="cell">365 Days, 365 Days, 365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">ad.adopx.net</div>
      <div class="cell">bdswtch_sync, moxuuid</div>
      <div class="cell">Third party</div>
      <div class="cell">A few seconds, A few seconds</div>
    </div>
    <div class="table-row">
      <div class="cell">rlcdn.com</div>
      <div class="cell">pxrc, rlas3</div>
      <div class="cell">Third party</div>
      <div class="cell">60 Days, 365 Days</div>
    </div>
    <div class="table-row">
      <div class="cell">3lift.com</div>
      <div class="cell">tluid</div>
      <div class="cell">Third party</div>
      <div class="cell">3 Months</div>
    </div>
  </div>

  <a id="2"></a>
  <h2>Where Can I Get Further Information?</h2>
  <p>
    If you would like to understand more about cookies, you can find out more
    information at
    <a href="www.aboutcookies.org" target="_blank">www.aboutcookies.org</a> and
    <a href="www.allaboutcookies.org" target="_blank">www.allaboutcookies.org</a
    >.
  </p>

  <a id="3"></a>
  <h2>Managing Cookies</h2>
  <p>Your cookie preferences can be adjusted in the settings.</p>
  <p>
    You can see what cookies have been set using your browser. Browser settings
    will also allow you to manage cookies, including through turning cookies
    off. Please note that turning off certain cookies will mean that our site
    will not work properly - we have explained above which cookies are strictly
    necessary to make our site function.
  </p>
  <p>
    To find out more information on how to manage cookies, please visit the link
    relevant to your browser:
  </p>

  <p>
    <a href="https://support.google.com/chrome/answer/95647" target="_blank"
      >Google Chrome</a
    >
  </p>
  <p>
    <a
      href="https://support.microsoft.com/en-gb/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd"
      target="_blank"
      >Microsoft Edge</a
    >
  </p>
  <p>
    <a
      href="https://support.mozilla.org/en-US/products/firefox/protect-your-privacy/cookies"
      target="_blank"
      >Mozilla Firefox</a
    >
  </p>
  <p>
    <a
      href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
      target="_blank"
      >Microsoft Internet Explorer</a
    >
  </p>
  <p>
    <a
      href="https://help.opera.com/en/latest/web-preferences/#cookies"
      target="_blank"
      >Opera</a
    >
  </p>
  <p>
    <a
      href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac"
      target="_blank"
      >Safari (Mac)</a
    >
  </p>
  <p>
    <a href="https://support.apple.com/en-gb/HT201265" target="_blank"
      >Safari (IOS)</a
    >
  </p>

  <p>
    We may update this Cookie Policy from time to time in order to reflect, for
    example, changes to the cookies we use or for other operational, legal or
    regulatory reasons. Please re-visit this Cookie Policy regularly to stay
    informed about our use of cookies and related technologies.
  </p>
</div>
